<template>
  <div>
    <BaseFrame
      cancelText=""
      clearText=""
      :infosArr="infos"
    >
      <div class="container" slot="content">
        <div style="margin-bottom: 20px;">
          <lk-card>
            <ApprovalFlow :workNo="workNo"></ApprovalFlow>
          </lk-card>
        </div>
        <div>
          <lk-card title='返利详情'>
            <returnProfitDetail
              :formObject="detailObject"
              :fieldData="drugInfo"
              :config="returnProfitContents"
            ></returnProfitDetail>
          </lk-card>
        </div>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import ApprovalFlow from '../../components/ApprovalFlow.vue';
import returnProfitDetail from '../../components/returnProfitDetail.vue';
import utils from '../../libs/utils';
import finance from '../../services/finance';

export default {
  name: 'otherProfitLogCheck',
  components: {
    BaseFrame,
    returnProfitDetail,
    ApprovalFlow,
  },
  data() {
    return {
      workNo: '',
      infos: [],
      drugInfo: {},
      detailObject: {},
      returnProfitContents: [
        [
          {
            type: 'span',
            title: '门店',
            key: 'storeName'
          },
          {
            type: 'span',
            title: '供应商',
            key: 'supplierName'
          },
        ],
        [
          {
            type: 'inputSearch',
            title: '申请商品',
            isShowInputSearch: false,
            value: '',
            showFields: [
              {
                title: '商品编码：',
                key: 'serialCode'
              },
              {
                title: '通用名：',
                key: 'approvedName'
              },
              {
                title: '商品名：',
                key: 'goodsName'
              },
              {
                title: '规格：',
                key: 'spec'
              },
              {
                title: '包装单位：',
                key: 'minPkgUnitName'
              },
              {
                title: '生产厂家：',
                key: 'producer'
              },
            ]
          }
        ],
        [
          {
            type: 'span',
            title: '验收单号',
            key: 'inspectionCode'
          },
          {
            type: 'span',
            title: '返利方式',
            key: 'rebateWay'
          },
        ],
        [
          {
            type: 'span',
            title: '返利金额',
            key: 'rebateAmount'
          },
          {
            type: 'upload',
            title: '审批附件',
            isCanEdit: false,
            uploadInfo: [
              {
                appendixName: '',
                appendixUrl: '',
              },
            ]
          },
        ],
        [
          {
            type: 'span',
            title: '申请备注',
            key: 'remark'
          },
        ]
      ]
    }
  },
  methods: {
    getData() {
      finance.getReturnProfitDetail({ rebateId: this.$route.params.id }).then(res => {
        if (res.data.status === 200) {
          let data = res.data.data;
          this.workNo = data.financeRebateRecordInfoVo.workCode;
          this.drugInfo = data.financeRebateRecordInfoVo;
          this.detailObject = data.financeRebateRecordInfoVo;
          this.$set(this.returnProfitContents[1][0], 'value', data.financeRebateRecordInfoVo.serialCode);
          this.$set(this.returnProfitContents[3][1], 'uploadInfo', data.bizExtraVos);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    }
  },
  mounted() {
    this.getData();
  }
}
</script>
<style lang="less" scoped>

</style>